import React from 'react';
import { Link } from 'react-router-dom';
//import { BiSolidObjectsHorizontalLeft } from "react-icons/bi";
import DocumentMeta from 'react-document-meta';

const Home = () => {

    return (<DocumentMeta {
        ...{
            title: 'Ares Electrónica Industrial S.A.',
            description: 'Nuestros valores caracterizan a ARES desde sus inicios, permitiendo mantener los estándares de atención y calidad que nuestros clientes desean.',
            canonical: 'https://' + window.location.host + '/',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'inicio, ares, ares electronica, ares electronica industrial, ares electronica industrial sa'
                }
            }
        }
    }>
        <div id="home" className="home-banner-area">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 ml-auto">
                        <div className="banner-content">
                            <h1>
                                Experiencia y compromiso.
                            </h1>
                            <p>
                                Nuestros valores caracterizan a ARES desde sus inicios, permitiendo mantener los estándares de atención y calidad que nuestros clientes desean.
                            </p>
                            <div className="btn-group">
                                <Link to="/nosotros" className="primary-btn">Acerca de nosotros</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section id="team" className="team-section pb-60 first-home-line">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6">
                        <div className="item-single mb-30">
                            <div className="image">
                                <a href="/productos"><img src="assets/img/home/bomba.png" alt="bomba dx" /></a>
                            </div>
                            <div className="content">
                                <h3><a href="/productos">Productos</a></h3>
                                <span>Encontrá el producto que estás necesitando</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="item-single mb-30">
                            <div className="image">
                                <a href="/descargas"><img src="assets/img/home/descargas.jpg" alt="descargas" /></a>
                            </div>
                            <div className="content">
                                <h3><a href="/descargas">Descargas</a></h3>
                                <span>Manuales, guías de instalación y mucho más</span>
                            </div>

                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="item-single mb-30">
                            <div className="image">
                                <a href="/servicios"><img src="assets/img/home/servicios.jpg" alt="servicios"/></a>
                            </div>
                            <div className="content">
                                <h3><a href="/servicios">Servicios</a></h3>
                                <span>Acesoramiento y atención a los clientes</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="service-section-two pb-70">
            <div className="container">
                <div className="row no-wrap align-items-center">
                    <div className="col-lg-4 col-md-12">
                        <div className="content mb-30">
                            <h2>
                                Aplicaciones
                            </h2>
                            <h5>
                                Estamos en la industria
                            </h5>
                            <p>
                                Nuestros productos y servicios son utilizados en una amplia gama de aplicaciones.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12">
                        <div className="item-single">
                            <div class='image-container'>
                                <div className='image-left'>
                                    <div className='image-left-or-right-content'>
                                        <div className='image-left-or-right-content-container'>
                                            <h3><Link to="aplicaciones/tratamiento-de-aguas" className="text-info">Tratamiento de aguas</Link></h3>
                                            <p className="text-info mb-5">Agua de consumo, efluentes y más</p>
                                            <Link to="aplicaciones/tratamiento-de-aguas" className="project-btn">Detalles</Link>

                                        </div>
                                    </div>
                                </div>
                                <div className='image-right'>
                                    <div className='image-left-or-right-content'>
                                        <div className='image-left-or-right-content-container'>
                                            <h3><Link to="aplicaciones/agroindustria" className="text-info">Agroindustria</Link></h3>
                                            <p className="text-info mb-5">Sanitizantes, insecticidas y más</p>
                                            <Link to="aplicaciones/agroindustria" className="project-btn">Detalles</Link>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section >

        <section id="about" className="about-section pb-100 mt-3">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="about-image">
                            <img src="assets/img/home/nosotros.jpg" alt="nosotros" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content mb-30">
                            <span className="sub-title">Acerca de nosotros</span>
                            <h2>
                                Estamos para acompañar<span> tu proyecto</span>
                            </h2>
                            <p>
                                Nuestro departamento técnico de ventas y de atención al cliente se encuentran siempre dispuestos a responder consultas por dudas que puedan presentarse en un proyecto o instalación para llegar al mejor resultado posible.
                            </p>
                            <div className="content-list">
                                <i className="bx bx-cog" />
                                <h6>Gama de productos para proyectos</h6>
                            </div>
                            <div className="content-list">
                                <i className="bx bx-wrench" />
                                <h6>Ingenieros con más de 20 años de experiencia en el rubro</h6>
                            </div>
                            <div className="content-list">
                                <i className="bx bx-recycle" />
                                <h6>Compromiso ambiental fabricando productos duraderos</h6>
                            </div>
                            <div className="content-list">
                                <i className="bx bx-pin" />
                                <h6>Equipamiento personalizado a las necesidades del cliente</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </DocumentMeta>
    );
}

export default Home;